/**
 * Статус отчета - доступен
 * @type {number}
 */
const REPORT_STATE_READY = 10;
/**
 * Статус отчета - ошибка
 * @type {number}
 */
const REPORT_STATE_ERROR = 2;


export default {
    data() {
        return {
            allowedLanguages: ['ru', 'en'],
        }
    },
    methods: {
        getLangTitle(locale) {
            const languages = this.$tm('lang.main.language');

            return languages[_.findIndex(languages, {key: locale})]['title']
        },
        getShortName(locale) {
            const languages = this.$tm('lang.main.language');

            return languages[_.findIndex(languages, {key: locale})]['short']
        },
        getBaseCaption(base) {
            const bases = this.getBases();
            const selectBase = bases[base];
            const baseNotExists = _.isUndefined(selectBase) || _.isNull(selectBase);

            if (baseNotExists) {
                this.switchToDefaultBase()
            }

            return !baseNotExists ? selectBase['caption'] : bases['msk']['short'];
        },
        /**
         * Статус отчета/проекта
         * @param value
         * @return {*}
         */
        getState(value) {
            switch (value) {
                case REPORT_STATE_READY:
                    return this.$tm('lang.main.table.state')[0];
                case REPORT_STATE_ERROR:
                    return this.$tm('lang.main.table.state')[2];
                default:
                    return this.$tm('lang.main.table.state')[1];
            }
        },
        switchToDefaultBase() {
            window.location.href = '/' + window.locale + '/changedb/msk';
        },
        getBases() {
            const bases = this.$tm('lang.main.bases')
            const currencies = this.$tm('lang.main.db_currency')

            let result = {}

            for (let base of bases) {
                result[base.name] = {
                    "name": base['name'],
                    "lng": 'ru',
                    "caption": base['caption'],
                    "short": base['short'],
                    "engine": base['engine'],
                    "currency": currencies[base['currency']]
                }
            }

            return result
        }
    }
}
